module.exports = __webpack_public_path__ + "static/media/insta.7f86ab62.jpg";